export default __webpack_public_path__ + "static/media/RemovePanelIcon.ae3c4ded.svg";